import Swiper from 'swiper';
import {
    Autoplay,
    Navigation,
    Pagination,
    EffectFade,
    Thumbs,
} from 'swiper/modules';

/**
 * Site Sliders
 *
 * - Site Carousel
 * - News Carousel
 */
export default function siteSliders() {
    /**
     * Site Carousel
     */
    // Site carousel thumbs
    const siteCarouselThumbs = new Swiper('.site-carousel-thumbs', {
        loop: false,
        spaceBetween: '10%',
        slidesPerView: 1.5,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            576: {
                slidesPerView: 2.5,
            },
            768: {
                slidesPerView: 3.5,
            },
            992: {
                slidesPerView: 4.5,
                spaceBetween: '5%',
            },
            1200: {
                slidesPerView: 5,
                spaceBetween: '5%',
            },
            1600: {
                slidesPerView: 5,
                spaceBetween: '7%',
            },
        },
    });

    // Site Carousel
    new Swiper('.site-carousel', {
        // Modules
        modules: [Autoplay, EffectFade, Thumbs],
        autoHeight: true,
        loop: false,
        speed: 700,
        // loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        thumbs: {
            swiper: siteCarouselThumbs,
        },
    });

    /**
     * News Carousel
     */
    new Swiper('.news-carousel', {
        loop: false,
        spaceBetween: 30,
        slidesPerView: 1.25,
        freeMode: true,
        breakpoints: {
            576: {
                slidesPerView: 2.25,
            },
            768: {
                slidesPerView: 2.5,
            },
            992: {
                slidesPerView: 3.75,
            },
            1200: {
                slidesPerView: 4,
            },
        },
    });
}
